import { Button, Tooltip } from '@customerio/pluma-components/react';
import { usePermissions } from '@customerio/hydra-permissions/react';
import { generatePath } from '@/services/router/generate-path';

type CreateBroadcastButtonProps = {
  workspaceId: number;
};

/**
 * The page's primary action. The create form is still served by the embedded app, and
 * `source` tells it which entry point the reader came from.
 */
export function CreateBroadcastButton({ workspaceId }: CreateBroadcastButtonProps) {
  const { hasPermission } = usePermissions();
  const canCreate = hasPermission('journeys/broadcasts/create');
  const href = generatePath(
    '/workspaces/:workspaceId/journeys/broadcasts/new',
    { workspaceId: String(workspaceId) },
    { source: 'Broadcasts' },
  );

  return (
    <Tooltip isDisabled={canCreate} content="Contact an Admin to access this feature." isCustom>
      {(context) => (
        <Button
          variant="primary"
          isDisabled={!canCreate}
          href={canCreate ? href : undefined}
          ref={context.reference.setReference}
          {...context.reference.getReferenceProps()}
        >
          Create broadcast
        </Button>
      )}
    </Tooltip>
  );
}
